import { Box, BoxProps, Typography } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Property } from 'entities/Property/model/types/PropertySchema';

import { PropertyCardRow } from './PropertyCardRow';

type PropertyCardInfoProps = {
    propertyItem: Property;
} & BoxProps;

export const PropertyCardInfo = memo(
    ({ mb, propertyItem }: PropertyCardInfoProps) => {
        const { t } = useTranslation();

        return (
            <Box mb={mb}>
                <Typography variant="h4" mb="8px">
                    {t('Contact Information')}
                </Typography>
                <PropertyCardRow
                    bordered
                    name={t('Phone')}
                    value={propertyItem.propertyPhoneNumber}
                />
                <PropertyCardRow
                    bordered
                    name={t('Email')}
                    value={propertyItem.propertyEmail}
                />
            </Box>
        );
    },
);
